import { ButtonBase, ButtonBaseProps } from '@mui/material';

export default function QSButtonBase({ sx, ...props }: ButtonBaseProps) {
  return <ButtonBase {...props} />;
}
